import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import CONFIG from '@webclient/layouts/main/config';
import { createGlobalStyle } from 'styled-components';

export const ToastGlobalStyles = createGlobalStyle`

    :root {
        --toastify-toast-width: content-fit;
        --toastify-toast-bd-radius: 16px;
        --toastify-toast-max-height: 134px;
    }

    .Toastify__toast-container--top-right {
        margin-top: ${CONFIG.HEADER_HEIGHT - CONFIG.HEADER.PADDING_Y}px;
        padding: 0px;
        border-top-right-radius: var(--toastify-toast-bd-radius);
        border-top-left-radius: var(--toastify-toast-bd-radius);
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        @media (max-Width: 600px) {
            width: calc(100% - 20px);
            left: 10px;
            top: 10px;
            border-radius: 16px;
        }
    }

    .Toastify__toast {
        border-top-right-radius: var(--toastify-toast-bd-radius);
        border-top-left-radius: var(--toastify-toast-bd-radius);
        border-radius: var(--toastify-toast-bd-radius);
        padding: 0;
        margin-bottom: 16px;
    }

    .Toastify__toast-body {
        padding: 0;
        padding-inline-start: 10px;
        margin: 0;
    }

    .Toastify__progress-bar {
        bottom: 0;
        height: 4px;
        opacity: 0.8;
    }

`;

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const StyledHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  position: 'relative',
  justifyContent: 'space-between',
  marginBlockEnd: theme.spacing(1),
}));

export const StyledAvatarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSquare',
})<{ isSquare?: boolean }>(({ theme, isSquare }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: isSquare ? theme.spacing(2) : '50%',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.grey[800]
      : theme.palette.grey[200],
  color: theme.palette.text.secondary,
  fontSize: '1.5rem',
  flexShrink: 0,
}));

export const StyledInfo = styled(Box)(({ theme }) => ({
  flex: 1,
  maxWidth: theme.spacing(70),
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
  height: theme.spacing(9),
}));

export const StyledDontShowContainer = styled(Stack)(({ theme }) => ({
  width: theme.spacing(34.75),
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledActionButtonsContainer = styled(Stack)(({ theme }) => ({
  width: theme.spacing(38),
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'buttonType',
})<{ buttonType?: 'primary' | 'secondary' }>(({ theme, buttonType }) => ({
  textTransform: 'none',
  color:
    buttonType === 'primary'
      ? theme.palette.primary.main
      : theme.palette.text.secondary,
  fontWeight:
    buttonType === 'primary'
      ? theme.typography.fontWeightBold
      : theme.typography.fontWeightMedium,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const StyledProgressBarContainer = styled(Box)<{ progress: number }>(
  ({ theme, progress }) => ({
    width: '100%',
    height: theme.spacing(1),
    backgroundColor: theme.palette.grey[200],
    marginTop: theme.spacing(1),
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: `${progress}%`,
      backgroundColor: theme.palette.primary.main,
      transition: 'width 0.3s ease-in-out',
    },
  }),
);
